import axiosInstance from './axiosInstance';

export const loginUser = async (username: string, password: string) => {
  const response = await axiosInstance.post('/auth/jwt/create/', {
    username,
    password,
  });
  return response.data;
};

export const registerUser = async (username: string, email: string, password: string) => {
  const response = await axiosInstance.post('/auth/users/', {
    username,
    email,
    password,
  });
  return response.data;
};

// Get current user data (including is_staff)
export const getCurrentUser = async () => {
  const response = await axiosInstance.get('/auth/users/me/');
  return response.data;
};

// Optionally, if you have a backend logout endpoint to invalidate tokens
export const logoutUser = async () => {
  // Assuming your backend has a logout endpoint that invalidates the token
  // await axiosInstance.post('/auth/jwt/destroy/');
  // For now, we just clear local state, as per the LogoutButton component
  return true;
};
